import { useState } from "react"

import { pluralize } from "web/services/inflector"
import { isNonEmptyArray } from "web/services/helpers"

import routes from "web/routes/constants"

import Header from "./Header"
import Asset from "./Asset"
import Deal from "./Deal"
import Sale from "./Sale"

export default function AssetLocationCard({
  primarySubject,
  location,
  assets,
  assetIds = [],
  deals,
  dealIds = [],
  sales,
  saleIds = [],
  onItemClick,
  onSelectionChanged,
  onClose,
}) {
  const haveAssets = isNonEmptyArray(assets)
  const haveDeals = isNonEmptyArray(deals)
  const haveSales = isNonEmptyArray(sales)

  const numberOfAssets = haveAssets ? assets.length : assetIds.length
  const numberOfDeals = haveDeals ? deals.length : dealIds.length
  const numberOfSales = haveSales ? sales.length : saleIds.length

  const showToggle = numberOfAssets + numberOfDeals + numberOfSales > 1
  const selectionEnabledInHeader = numberOfAssets === 1

  const [expandedIndex, setExpandedIndex] = useState(0)

  function goToObject(subjectType, id) {
    if (onItemClick) {
      onItemClick(subjectType, id)
    } else if (subjectType === "sale") {
      window.Turbo.visit(`/markets/global/sales/view/${id}`)
    } else {
      window.Turbo.visit(routes.tlo(pluralize(subjectType), "all", null, id))
    }
  }

  return (
    <div className="mb-4 min-h-sm w-64 cursor-pointer rounded-md bg-white pb-2 shadow-altrio-1">
      <Header
        title={primarySubject.name}
        location={location}
        primarySubject={primarySubject}
        selectionEnabled={selectionEnabledInHeader}
        onSelectionChanged={onSelectionChanged}
        onClick={() => goToObject("asset", primarySubject.id)}
        onClose={onClose}
      />
      <div>
        {(haveAssets ? assets : assetIds).map((el, i) => {
          return (
            <Asset
              key={i}
              asset={haveAssets ? el : undefined}
              assetId={!haveAssets ? el : undefined}
              location={location}
              showToggle={showToggle}
              isExpanded={expandedIndex === i}
              selectionEnabled={!selectionEnabledInHeader}
              onToggle={() => setExpandedIndex(i)}
              onClick={() => goToObject("asset", haveAssets ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
        {(haveDeals ? deals : dealIds).map((el, i) => {
          const dealIndex = numberOfAssets + i

          return (
            <Deal
              key={i}
              deal={haveDeals ? el : undefined}
              dealId={!haveDeals ? el : undefined}
              showToggle={showToggle}
              isExpanded={expandedIndex === dealIndex}
              selectionEnabled={false}
              onToggle={() => setExpandedIndex(dealIndex)}
              onClick={() => goToObject("deal", haveDeals ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
        {(haveSales ? sales : saleIds).map((el, i) => {
          const saleIndex = numberOfAssets + numberOfDeals + i

          return (
            <Sale
              key={i}
              sale={haveSales ? el : undefined}
              saleId={!haveSales ? el : undefined}
              showToggle={showToggle}
              isExpanded={expandedIndex === saleIndex}
              selectionEnabled={false}
              onToggle={() => setExpandedIndex(saleIndex)}
              onClick={() => goToObject("sale", haveSales ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
      </div>
    </div>
  )
}
